import { SyntheticEvent } from "react";
import { iconsImgs } from "./utils/icons";
import AuthClient from "./api/AuthClient";
import { defaultImgs } from "./utils/defaultImages";

const handleImgError = (event: SyntheticEvent<HTMLImageElement>, gender: string | undefined) => {

    if (gender) {
        const imgElement = event.target as HTMLImageElement;
        imgElement.src = gender === "Male" ? iconsImgs.Boy : iconsImgs.Girl;
    }
};

export default handleImgError;

export const userDefaultImage = () => {
    const authClient: AuthClient = new AuthClient();
    const userInfo = authClient.getAuthenticationResponse();
    return userInfo?.gender.toString() === "Female" ? iconsImgs.Girl : iconsImgs.Boy;
}

export const handleClubImgError = (event: SyntheticEvent<HTMLImageElement>) => {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = defaultImgs.ClubImg;
};
